import { FilterTemplate } from '../types/ai';

export const FILTER_TEMPLATES: FilterTemplate[] = [
  {
    id: 'logged-in-users',
    name: 'Only Logged-in Users',
    description: 'Allow events only when userId exists',
    category: 'user-behavior',
    yamlTemplate: `filters:
  - byConditions:
      action: allow
      when:
        inputPathExists:
          inputPath: {{userIdPath}}`,
    placeholders: ['userIdPath'],
    examples: ['properties.userId', 'context.userId', 'traits.userId']
  },
  {
    id: 'exclude-bots',
    name: 'Exclude Bot Traffic',
    description: 'Filter out known bot user agents',
    category: 'data-quality',
    yamlTemplate: `filters:
  - byConditions:
      action: deny
      when:
        stringContains:
          ignoreCase: true
          inputPath: context.userAgent
          value: {{botPattern}}`,
    placeholders: ['botPattern'],
    examples: ['bot', 'crawler', 'spider']
  },
  {
    id: 'event-whitelist',
    name: 'Specific Events Only',
    description: 'Allow only specified event types',
    category: 'performance',
    yamlTemplate: `filters:
  - byEventNames:
      action: allow
      events:
        {{#eventNames}}
        - {{.}}
        {{/eventNames}}`,
    placeholders: ['eventNames'],
    examples: ['page,track', 'identify,track']
  },
  {
    id: 'consent-based',
    name: 'Consent-Based Filtering',
    description: 'Filter based on user consent flags',
    category: 'privacy',
    yamlTemplate: `filters:
  - byConditions:
      action: allow
      when:
        booleanEqual:
          inputPath: {{consentPath}}
          value: true`,
    placeholders: ['consentPath'],
    examples: ['context.consent.analytics', 'properties.hasConsent']
  },
  {
    id: 'geographic-filter',
    name: 'Geographic Filtering',
    description: 'Filter events based on user location',
    category: 'user-behavior',
    yamlTemplate: `filters:
  - byConditions:
      action: allow
      when:
        stringIn:
          inputPath: {{locationPath}}
          values:
            {{#allowedCountries}}
            - {{.}}
            {{/allowedCountries}}`,
    placeholders: ['locationPath', 'allowedCountries'],
    examples: ['context.location.country', 'US,CA,UK']
  },
  {
    id: 'exclude-test-events',
    name: 'Exclude Test Events',
    description: 'Filter out events from test environments',
    category: 'data-quality',
    yamlTemplate: `filters:
  - byConditions:
      action: deny
      when:
        or:
          - stringEqual:
              inputPath: context.environment
              value: test
          - stringEqual:
              inputPath: context.environment
              value: development
          - booleanEqual:
              inputPath: properties.isTest
              value: true`,
    placeholders: [],
    examples: []
  },
  {
    id: 'minimum-value-filter',
    name: 'Minimum Value Filter',
    description: 'Filter events based on minimum numeric value',
    category: 'data-quality',
    yamlTemplate: `filters:
  - byConditions:
      action: allow
      when:
        numericGreaterThanOrEqual:
          inputPath: {{valuePath}}
          value: {{minimumValue}}`,
    placeholders: ['valuePath', 'minimumValue'],
    examples: ['properties.revenue', '10.00']
  },
  {
    id: 'email-domain-filter',
    name: 'Email Domain Filter',
    description: 'Filter events based on email domain',
    category: 'user-behavior',
    yamlTemplate: `filters:
  - byConditions:
      action: allow
      when:
        stringEndsWith:
          inputPath: {{emailPath}}
          value: {{allowedDomain}}`,
    placeholders: ['emailPath', 'allowedDomain'],
    examples: ['properties.email', '@company.com']
  }
];

export const getTemplatesByCategory = (category: FilterTemplate['category']): FilterTemplate[] => {
  return FILTER_TEMPLATES.filter(template => template.category === category);
};

export const getTemplateById = (id: string): FilterTemplate | undefined => {
  return FILTER_TEMPLATES.find(template => template.id === id);
};
